import * as React from 'react';
import { UIHeading4, UIText2, Button } from '@cian/ui-kit';
import { useIsDesktop } from '@cian/valuation-utils-component';

import * as styles from './styles.css';

interface IDemandRequestProps {
  description: React.ReactNode;
  onActionClick?(): void;
  ref?: React.Ref<HTMLDivElement>;
}

export function DemandRequest({ description, onActionClick, ref }: IDemandRequestProps): React.JSX.Element {
  const isDesktop = useIsDesktop();

  return (
    <div ref={ref} className={styles['container']}>
      <div className={styles['content']}>
        <UIHeading4>Найдите риелтора</UIHeading4>
        <div className={styles['text']}>
          <UIText2>{description}</UIText2>
        </div>
      </div>
      {onActionClick && (
        <div className={styles['button']}>
          <Button theme="fill_secondary" size={isDesktop ? 'XS' : 'M'} fullWidth={!isDesktop} onClick={onActionClick}>
            Оставить заявку
          </Button>
        </div>
      )}
    </div>
  );
}
